// ============================================
// Support Page - Redirect to LINE
// ============================================

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Support = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // LINE Official Account URL
    const lineUrl = 'https://lin.ee/uGDyY5w';
    
    // Open LINE in new tab
    window.open(lineUrl, '_blank');
    
    // Navigate back to previous page or home
    navigate(-1);
  }, [navigate]);

  return null;
};

export default Support;

